<template>
  <div
    class="col-md-5 px-2 product-dropdown"
    :class="{ 'section-hidden' : !isSectionHidden }"
  >
    <header class="header-section product">
      <h2 class="middle-header-text text-center me-2 d-inline-block">
        Products
      </h2>
      <!-- <a class="view-all-text cursor-pointer align-middle">View All</a> -->
    </header>

    <div class="row brand-dept-cat constraint-max-height">
      <div
        v-for="(brand, index) in topMenuBrands"
        :key="`${brand.name}_${brand.id}_${index}`"
        :class="brandColumnClass(brand.sub_brands ? brand.sub_brands.length : 0)"
      >
        <div class="row">
          <h6
            class="title text-uppercase text-start brand-text cursor-pointer"
            @click="beginSearch(brand.id)"
          >
            {{ brand.name }}
          </h6>
          
          <!-- Handle Sub-brands with full hierarchy -->
          <template v-if="brand.sub_brands && brand.sub_brands.length > 0">
            <div
              v-for="(subBrand, subBrandIndex) in brand.sub_brands"
              :key="`${subBrand.name}_${subBrand.id}_${subBrandIndex}`"
              :class="subbrandColumnClass(brand.sub_brands ? brand.sub_brands.length : 0)"
            >
              <h6
                class="text-uppercase text-start department-text sub-brand-text cursor-pointer title"
                @click="beginSearch(brand.id, subBrand.id)"
              >
                {{ subBrand.name }}
              </h6>
              
              <!-- Sub-brand departments -->
              <template v-if="subBrand.departments && subBrand.departments.length > 0">
                <div
                  v-for="(department, deptIndex) in subBrand.departments"
                  :key="`${department.name}_${department.id}_${deptIndex}`"
                >
                  <h6
                    class="sub-title text-uppercase text-start department-text ps-1 cursor-pointer"
                    @click="beginSearch(brand.id, subBrand.id, department.id)"
                  >
                    {{ department.name }}
                  </h6>
                  <div class="mb-3" v-if="department.categories && department.categories.length > 0">
                    <p
                      v-for="(category, catIndex) in department.categories"
                      :key="`${category.name}_${category.id}_${catIndex}`"
                      class="category-text mb-2 ps-3 text-start cursor-pointer"
                      @click="beginSearch(brand.id, subBrand.id, department.id, category.id)"
                    >
                      {{ category.name }}
                    </p>
                  </div>
                </div>
              </template>
              
              <!-- Direct categories under sub-brand (no department) -->
              <template v-else-if="subBrand.categories && subBrand.categories.length > 0">
                <div class="mb-3">
                  <p
                    v-for="(category, catIndex) in subBrand.categories"
                    :key="`${category.name}_${category.id}_${catIndex}`"
                    class="category-text mb-2 ps-2 text-start cursor-pointer"
                    @click="beginSearch(brand.id, subBrand.id, null, category.id)"
                  >
                    {{ category.name }}
                  </p>
                </div>
              </template>
            </div>
          </template>
          
          <!-- Handle direct departments under brand (no sub-brand) -->
          <template v-else-if="brand.departments && brand.departments.length > 0">
            <div
              v-for="(department, deptIndex) in brand.departments"
              :key="`${department.name}_${department.id}_${deptIndex}`"
              :class="subbrandColumnClass(0)"
            >
              <h6
                class="text-uppercase text-start department-text sub-brand-text cursor-pointer sub-title ps-1"
                @click="beginSearch(brand.id, null, department.id)"
              >
                {{ department.name }}
              </h6>
              <div class="mb-3" v-if="department.categories && department.categories.length > 0">
                <p
                  v-for="(category, catIndex) in department.categories"
                  :key="`${category.name}_${category.id}_${catIndex}`"
                  class="category-text mb-2 ps-2 text-start cursor-pointer"
                  @click="beginSearch(brand.id, null, department.id, category.id)"
                >
                  {{ category.name }}
                </p>
              </div>
            </div>
          </template>
          
          <!-- Handle direct categories under brand (no sub-brand, no department) -->
          <template v-else-if="brand.categories && brand.categories.length > 0">
            <div :class="subbrandColumnClass(0)">
              <div class="mb-3">
                <p
                  v-for="(category, catIndex) in brand.categories"
                  :key="`${category.name}_${category.id}_${catIndex}`"
                  class="category-text mb-2 ps-1 text-start cursor-pointer"
                  @click="beginSearch(brand.id, null, null, category.id)"
                >
                  {{ category.name }}
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="row filter-section cs-hide-on-sm">
        <p-button
          class="filter-search-button"
          v-on="$listeners"
          @click="onSearchClicked"
        >
          <img
            src="../../../../../../public/img/icons/arrow-up-white.png"
            alt=""
            class="btn-icon"
          >
          FILTER SEARCH
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import componentHelpers from '~/mixins/componentHelpers'
import { EventBus } from '~/helpers/miscs'
import PButton from '~/components/core/PButton'

export default {
  name: 'ProductSection',
  mixins: [componentHelpers],
  components: { PButton },
  data () {
    return {
      params: {
        brand: null,
        sub_brand: null,
        department: null,
        category: null
      }
    }
  },
  computed: {
    ...mapGetters({
      commonMenu: 'menus/commonMenu'
    }),
    topMenu () {
      return this.commonMenu?.top_menu
    },
    topMenuBrands () {
      return this.topMenu?.brands
    }
  },
  props: {
    isSectionHidden: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions({
      setSelectedCheckBox: 'menus/setSelectedCheckBox',
      setSelectedChildrenCheckBox: 'menus/setSelectedChildrenCheckBox',
      clearFilter: 'catalog_products/clearFilter',
      fetchProductFilterTabMenu: 'menus/fetchProductFilterTabMenu'
    }),
    brandColumnClass (subBrandLength) {
      // Adjust column width based on content complexity
      if (subBrandLength > 2) return 'col-12'
      return subBrandLength ? `col-${subBrandLength * 3}` : 'col-3'
    },
    subbrandColumnClass (subBrandLength) {
      return subBrandLength ? 'col-4' : 'col-12'
    },
    onSearchClicked () {
      this.$emit('toggleSection')
    },
    beginSearch (brandId = null, subBrandId = null, departmentId = null, categoryId = null) {
      this.params.brand = brandId
      this.params.sub_brand = subBrandId
      this.params.department = departmentId
      this.params.category = categoryId
      this.$router.push({ name: 'products', query: Object.fromEntries(Object.entries(this.params).filter(([_, v]) => v != null)) })
      EventBus.$emit('close-product-popper')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-section {
    &.product {
        .view-all-text {
            font: normal normal normal 12px/14px Arial;
            letter-spacing: 0px;
            color: #31B4D6;
        }
    }
}
.filter-search-button {
  width: 158px;
  height: 52px;
  background-color: #E3E2E2 !important;
  padding: 5px 16px;
  display: block;
  margin: auto;
  border: 0 !important;
  .btn-icon {
    width: 20px;
    height: 20px;
    display: block;
    margin: auto;
    color: #fff;
  }
}
.brand-dept-cat {
    padding-top: 4px;

    .brand-text {
        &:hover {
            font-style: italic;
            text-decoration: underline;
        }
    }

    .sub-brand-text {
      padding-top: 2px;
    }

    .department-text:hover {
        font-style: italic;
        text-decoration: underline;
    }

    .category-text:hover {
        font-style: italic;
        text-decoration: underline;
    }
}

.filter-section {
  width: 100%;
  display: none;
  justify-content: center;
}
.product-dropdown {
  position: relative;
}

@media (max-width: 1280px) {
  .col-md-5 {
    width: 70%;
  }
  .filter-section {
    display: flex;
    position: absolute;
    bottom: 9px;
  }
  // The filter button is pinned over the category list (absolute), so reserve
  // room at the bottom of the list — otherwise it overlaps the last categories
  // and swallows their clicks.
  .brand-dept-cat {
    padding-bottom: 70px;
  }
  .section-hidden {
    display: none;
  }
}
@media (max-width: 700px) {
  .col-md-5 {
    width: 50%;
    .col-4, .col-12, .col-3 {
      width: 100%;
    }
  }
  .cs-hide-on-sm {
    display: none;
  }
}
</style>
